// extracted by css-extract-rspack-plugin
export default {"dialog":"CalculatorPromoCodeDialog-module__dialog--y_pfU"};